export default {
  savedTabsForDownload: [],
};
